import { useState, useRef } from "react";
import "./SubmitNote.css";

function SubmitNoteWindow() {
  const [isOpen, setIsOpen] = useState(true);
  const [isMinimized, setIsMinimized] = useState(false);
  const [note, setNote] = useState("");

  const terminalRef = useRef(null);
  const offset = useRef({ x: 0, y: 0 });

  /* ======================
     Shared drag helpers
  ====================== */

  const startDrag = (clientX, clientY) => {
    const rect = terminalRef.current.getBoundingClientRect();
    offset.current = {
      x: clientX - rect.left,
      y: clientY - rect.top,
    };
  };

  const moveWindow = (clientX, clientY) => {
    terminalRef.current.style.left = `${clientX - offset.current.x}px`;
    terminalRef.current.style.top = `${clientY - offset.current.y}px`;
  };

  const stopMouseDrag = () => {
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", stopMouseDrag);
  };

  const stopTouchDrag = () => {
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", stopTouchDrag);
  };

  /* ======================
     Mouse events
  ====================== */

  const onMouseDown = (e) => {
    startDrag(e.clientX, e.clientY);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", stopMouseDrag);
  };

  const onMouseMove = (e) => {
    moveWindow(e.clientX, e.clientY);
  };

  /* ======================
     Touch events (mobile)
  ====================== */

  const onTouchStart = (e) => {
    const touch = e.touches[0];
    startDrag(touch.clientX, touch.clientY);

    document.addEventListener("touchmove", onTouchMove, { passive: false });
    document.addEventListener("touchend", stopTouchDrag);
  };

  const onTouchMove = (e) => {
    e.preventDefault(); // stop scrolling
    const touch = e.touches[0];
    moveWindow(touch.clientX, touch.clientY);
  };

  /* ======================
     Submit
  ====================== */

  const handleSubmit = () => {
    if (!note.trim()) return;
    alert("✨ note sent 💕");
    setNote("");
  };

  if (!isOpen) return null;

  return (
    <div
      ref={terminalRef}
      className="note-terminal"
      style={{ top: "120px", left: "35%" }}
    >
      {/* Header */}
      <div
        className="note-header"
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      >
        <div className="window-buttons">
          <span className="button red" onClick={() => setIsOpen(false)} />
          <span
            className="button yellow"
            onClick={() => setIsMinimized(!isMinimized)}
          />
          <span className="button green" />
        </div>
        <span className="terminal-title">leave_a_note.exe</span>
      </div>

      {/* Body */}
      {!isMinimized && (
        <div className="note-body">
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder=">> would love your thoughts / recommendations on music, poetry, books, technology ✨"
          />
          <button onClick={handleSubmit}>send</button>
        </div>
      )}
    </div>
  );
}

export default SubmitNoteWindow;
